import React from 'lib/react';
import {
  EVGrid,
  EVSkeleton,
} from 'lib/components';
import PropTypes from 'prop-types';

import useMediaQuery from 'hooks/useMediaQuery';
import PaymentInformationStyles from './PaymentInformationLoaderStyles';

export default function PaymentInformationLoader({
  splitCardContainer,
  fullWidthInputFields,
}) {
  const classes = PaymentInformationStyles();
  const isMobile = useMediaQuery(640);
  return (
    <EVGrid container item direction="column">
      <EVGrid className={classes.fieldContainer} item>
        <EVSkeleton className={classes.heading} animation="wave" variant="rect" />
      </EVGrid>
      {isMobile && (
      <EVGrid className={classes.fieldContainer} item>
        <EVSkeleton className={classes.heading} animation="wave" variant="rect" />
      </EVGrid>
      )}
      <EVGrid className={classes.fieldContainer} item>
        <EVSkeleton className={fullWidthInputFields ? classes.cardInputTextFullWidth : classes.cardInputText} animation="wave" variant="rect" />
      </EVGrid>
      <EVGrid className={classes.fieldContainer} item>
        <EVSkeleton className={fullWidthInputFields ? classes.cardInputTextFullWidth : classes.cardInputText} animation="wave" variant="rect" />
      </EVGrid>
      <EVGrid className={classes.fieldContainer} container item direction="column">
        <EVGrid className={splitCardContainer ? classes.cardContainerSplit : classes.cardContainer} container item>
          <EVGrid className={classes.cardTypeContainer} item>
            <EVSkeleton className={classes.cardTypeOptions} animation="wave" variant="rect" />
          </EVGrid>
          <EVGrid
            className={fullWidthInputFields ? classes.cardNumberContainerFullWidth : classes.cardNumberContainer}
            item
          >
            <EVSkeleton className={fullWidthInputFields ? classes.cardInputTextFullWidth : classes.cardInputText} animation="wave" variant="rect" />
          </EVGrid>
        </EVGrid>
      </EVGrid>
      <EVGrid className={classes.fieldContainer} container item direction="column">
        <EVGrid className={classes.expirationContainer} container item>
          <EVGrid className={classes.monthContainer} container item direction="column">
            <EVSkeleton className={classes.monthField} animation="wave" variant="rect" />
          </EVGrid>
          <EVGrid className={classes.yearContainer} item>
            <EVSkeleton className={classes.yearField} animation="wave" variant="rect" />
          </EVGrid>
        </EVGrid>
      </EVGrid>
      <EVGrid className={classes.fieldContainer} item>
        <EVSkeleton className={classes.footer} animation="wave" variant="rect" />
      </EVGrid>
    </EVGrid>
  );
}

PaymentInformationLoader.propTypes = {
  splitCardContainer: PropTypes.bool.isRequired,
  fullWidthInputFields: PropTypes.bool.isRequired,
};
